import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import '../Checklist/index.css';
import './index.css';
import { Modal } from 'react-bootstrap';
import APIService from '../../Services/APIService';

const SelectAttributeModal = ({
  showOptionModal,
  onCancel,
  onSubmit,
  attributeInfo,
  selectedModalSupplierType,
}) => {
  const [state, setState] = useState({
    supplierTypeOption: [],
    selectedSupplierType: undefined,
  });
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      width: '50%',
      transform: 'translate(-50%, -50%)',
      padding: '5px 10px 10px',
      maxHeight: '550px',
      minHeight: '200px',
    },
  };

  const setSupplierTypeOption = (options, supplierAttribute, optionValueKey) => {
    if (options && options.length > 0) {
      let supplierTypeOption = [];
      options.forEach((supplierType) => {
        supplierTypeOption.push({
          value: supplierType[optionValueKey],
          label: supplierType.name,
          attributes:
            supplierType[supplierAttribute] != false
              ? supplierType[supplierAttribute]?.map((attribute) => {
                  if (attribute.hasOwnProperty('isChecked')) {
                    return attribute;
                  }
                  let checkedAttribute = Object.assign({}, attribute);
                  checkedAttribute.isChecked = true;
                  return checkedAttribute;
                })
              : [],
        });
      });
      setState({
        ...state,
        supplierTypeOption,
      });
    }
  };

  const getSupplierTypeList = async () => {
    let res = await APIService.get(`/v0/ui/dynamic-suppliers/supplier-type/`);
    if (res.status == 200)
      setSupplierTypeOption(Object.values(res?.data?.list), 'supplier_attributes', 'id');
  };

  const getBaseSupplierTypeList = async () => {
    let res = await APIService.get(`/v0/ui/dynamic-suppliers/base-supplier-type/`);
    if (res.status == 200)
      setSupplierTypeOption(Object.values(res?.data?.list), 'supplier_attributes', 'id');
  };

  const getBaseInventory = async () => {
    let res = await APIService.get(`/v0/ui/dynamic-inventory/base-inventory/`);
    if (res.status == 200)
      setSupplierTypeOption(Object.values(res?.data?.list), 'base_attributes', '_id');
  };

  const getInventoryList = async () => {
    let res = await APIService.get(`/v0/ui/dynamic-inventory/inventory/`);
    if (res.status == 200)
      setSupplierTypeOption(Object.values(res?.data?.list), 'inventory_attributes', '_id');
  };

  useEffect(() => {
    if (attributeInfo.attributeType === 'SUPPLIER_TYPE') {
      getSupplierTypeList();
    } else if (attributeInfo.attributeType === 'BASE_SUPPLIER_TYPE') {
      getBaseSupplierTypeList();
    } else if (attributeInfo.attributeType === 'INVENTORY_TYPE') {
      getBaseInventory();
    } else if (attributeInfo.attributeType === 'INVENTORY') {
      getInventoryList();
    }

    setState({
      ...state,
      selectedSupplierType: selectedModalSupplierType,
    });
  }, []);

  const onSelectSupplierType = (selectedSupplierType) => {
    setState({
      ...state,
      selectedSupplierType,
    });
  };

  const handleInputChange = (event, option) => {
    let { selectedSupplierType } = state;
    selectedSupplierType.attributes.forEach((attribute) => {
      if (attribute.name === option.name) {
        attribute.isChecked = event.target.checked;
      }
    });
    setState({
      ...state,
      selectedSupplierType,
    });
  };

  const renderOptionRow = (option, optionIndex) => {
    return option.type !== 'SUPPLIER_TYPE' &&
      option.type !== 'BASE_SUPPLIER_TYPE' &&
      option.type !== 'INVENTORY_TYPE' &&
      option.type !== 'INVENTORY' ? (
      <div className="form-control option-container" key={optionIndex}>
        <input
          type="checkbox"
          className="input-checkbox"
          checked={option.isChecked}
          onChange={(event) => handleInputChange(event, option)}
          disabled={option.isRequired}
        />
        {option.name}
      </div>
    ) : (
      <div />
    );
  };

  let { selectedSupplierType } = state;
  let supplierType;
  if (attributeInfo.attributeType === 'SUPPLIER_TYPE') {
    supplierType = 'Supplier Type';
  } else if (attributeInfo.attributeType === 'BASE_SUPPLIER_TYPE') {
    supplierType = 'Base Supplier Type';
  } else if (attributeInfo.attributeType === 'INVENTORY_TYPE') {
    supplierType = 'Base Inventory';
  } else if (attributeInfo.attributeType === 'INVENTORY') {
    supplierType = 'Inventory';
  }

  return (
    <Modal
      show={showOptionModal}
      onHide={onCancel}
      className={'theme-modal'}
      style={customStyles}
      id={''}
      size={'md'}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h3>Select Attributes for {supplierType}</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="createform">
          <div className="createform__form">
            <div className="createform__form__inline">
              <div className="form-control">
                <label>*Select {supplierType}</label>
                <Select
                  options={state.supplierTypeOption}
                  value={state.selectedSupplierType}
                  onChange={onSelectSupplierType}
                />
              </div>
            </div>
            <div className="createform__form">
              {selectedSupplierType
                ? selectedSupplierType.attributes.map(renderOptionRow)
                : undefined}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn--danger"
            onClick={() => onSubmit(state.selectedSupplierType, attributeInfo)}
          >
            Submit
          </button>{' '}
          <button type="button" className="btn btn--danger" onClick={onCancel}>
            Close
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default SelectAttributeModal;
